import { useContext } from "react";
import { TextsContext } from "context/textsContext";
import { useMyFavoritePlanForm } from "context/MyFavoritePlanFormContext";
import style from "scss/formLayout.module.scss";

const BackToHomeButton = () => {
    const { texts } = useContext(TextsContext);
    const { goToDashboard } = useMyFavoritePlanForm();

    return (
        <button type="button" className={style.backToHome} onClick={goToDashboard}>
            {texts?.favorite_plan_form_back_to_home ?? 'Back to Home'}
        </button>
    );
};

export default BackToHomeButton;
